<template>
  <div>
    <div v-show="value" class="fixed top-0 left-0 z-40 w-full h-full bg-overlay" />
    <div v-show="value" class="fixed top-0 left-0 z-40 w-full h-full overflow-hidden">
      <div class="absolute top-0 left-0 flex flex-wrap items-center justify-center w-full h-full p-5 overflow-x-auto">
        <div class="relative w-full max-w-xl px-5 pt-10 pb-6 bg-white xl:pb-10 xl:pt-12 xl:px-8">
          <div
            v-if="dismissable"
            class="absolute top-0 right-0 flex items-center justify-center mt-4 mr-4 space-x-1 text-sm leading-none transition-colors duration-200 ease-in-out cursor-pointer text-sn-gray-300 hover:text-sn-gray"
            @click="$emit('input', false)"
          >
            <span>
              {{ $t('popups.newVoucher.button.close') }}
            </span>
            <svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'w-4 h-4 fill-current text-sn-gray'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M274 54.1l-28.4-28.4-95.6 96.2-95.6-96.3L26 54.1l95.9 95.9L26 245.8l28.4 28.3L150 178l95.6 96.3 28.4-28.5-95.9-95.8L274 54.1"/></svg>
          </div>

          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Modal from '~brand-components/base/modal/modal.ts'

export default Modal.extend()
</script>
